"use client";

import * as process from "process";

import { CopyIcon } from "icons";
import Link from "next/link";
import React, { useState } from "react";
import { Button, Heading, ImageWrapper, Modal } from "ui-components";

interface IShareProps {
  day?: string;
}

export default function Share({ day }: Readonly<IShareProps>): JSX.Element {
  const [isShowModal, setIsShowModal] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const workPrideUrl = `${process.env.APP_URL}/work-pride-2026#${day}`;
  const facebookShareUrl = `http://www.facebook.com/sharer.php?u=${encodeURIComponent(
    workPrideUrl
  )}`;
  const linkedinShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
    workPrideUrl
  )}`;
  const pinterestShareUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
    workPrideUrl
  )}`;
  const mailShareUrl = `mailto:?subject=${encodeURIComponent(workPrideUrl)}`;

  const handleCopy = async (): Promise<void> => {
    await navigator.clipboard.writeText(workPrideUrl);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div>
      <Button
        className="!bg-[#FFFFFF] !w-20 py-2 text-blue-950 border border-blue-950 !text-lg"
        onPress={() => setIsShowModal(!isShowModal)}
      >
        Share
      </Button>
      <Modal
        animatedModalClassName="min-w-full md:min-w-[570px] py-10 px-[50px] flex flex-1 items-center justify-center"
        isOpen={isShowModal}
        onOpenChange={setIsShowModal}
      >
        <div className="flex flex-col gap-y-5">
          <Heading align="center">SHARE THIS</Heading>
          <div className="my-5 flex flex-col border p-5">
            <div className="flex gap-x-3">
              {isCopied ? (
                <span className="text-green-600">
                  Copied! &nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              ) : (
                <span className="text-gray-300">Copy URL</span>
              )}
              <CopyIcon
                className="flex justify-end mt-1"
                onClick={handleCopy}
              />
            </div>
            {workPrideUrl}
          </div>
        </div>
        <div className="max-w-[630px] w-full flex flex-row md:flex-row justify-center items-start gap-5">
          <div>
            <Link href={facebookShareUrl} target="_blank">
              <ImageWrapper
                src="/workpride/facebook-icon.png"
                alt="illustration"
                width={32}
                height={32}
              />
            </Link>
          </div>
          <div>
            <Link href={linkedinShareUrl} target="_blank">
              <ImageWrapper
                src="/workpride/linkedin-icon.png"
                alt="illustration"
                width={32}
                height={32}
              />
            </Link>
          </div>
          <div>
            <Link href={pinterestShareUrl} target="_blank">
              <ImageWrapper
                src="/workpride/pinterest-icon.png"
                alt="illustration"
                width={32}
                height={32}
              />
            </Link>
          </div>
          <div>
            <Link href={mailShareUrl}>
              <ImageWrapper
                src="/workpride/mail-icon.png"
                alt="illustration"
                width={32}
                height={32}
              />
            </Link>
          </div>
        </div>
      </Modal>
    </div>
  );
}
